var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-441 -714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "times-line",
    d: "M13.675,13.03,17.82,8.885a.5.5,0,0,0-.7-.7L12.97,12.325l-.7.7-4.15,4.145a.5.5,0,1,0,.705.7l4.15-4.145Z",
    transform: "translate(433.06 705.943)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "times-line-2",
    "data-name": "times-line",
    d: "M5.735,4.97,9.88.825a.5.5,0,0,0-.7-.7L5.03,4.265l-.7.7L.175,9.115a.5.5,0,1,0,.7.7L5.03,5.675Z",
    transform: "translate(450.998 714) rotate(90)",
    fill: "#FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.0429523434318b43fb4e3c33410db5b9.svg";